<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
<div class="pp11">
    <section class="hero grid vertical-center halves">
        <div class="clamped">
            <div class="content">
                <NuxtImg class="logo" src="/images/teasers/pp11/logo.png" :alt="$t('PP11.LOGO_ALT')" />
                <h3>{{ $t('PP11.LANDING_PAGE_LEADING') }}</h3>
                <p v-html="$t('PP11.LANDING_PAGE_INFO_CALLOUT')" />
                <div class="signup">
                    <p>{{ $t('PP11.LANDING_PAGE_SIGNUP_CALLOUT') }}</p>
                    <EmailSignup
                        subscriber-id="JackboxDirect2025"
                        :data-fields="[{ name: 'language', id: '4242', value: listrakLocale }]"
                        :button-text="$t('FORM.SUBMIT')"
                        button-style="outline"
                    />
                </div>
            </div>
            <div class="media">
                <NuxtImg class="logo" src="/images/teasers/pp11/logo.png" :alt="$t('PP11.LOGO_ALT')" />
                <button v-on:click="onVideoClick">
                    <NuxtImg src="/images/teasers/jackbox_direct_poster.png" alt="x" />
                </button>
            </div>
        </div>
    </section>
</div>
</template>

<script lang="ts">
import { type Component, defineComponent } from 'vue'
import { I18n } from '$services/i18n'
import CarouselModal from '$components/carousel/CarouselModal.vue'
import EmailSignup from '$components/forms/EmailSignup.vue'

export default defineComponent({
    components: {
        EmailSignup
    },

    computed: {
        listrakLocale() {
            return I18n.getLocaleForListrak(this.$i18n.locale)
        }
    },

    methods: {
        onVideoClick() {
            // TODO: we should teach this carousel how to deal
            // with data that didn't come from strapi
            void this.$showModal(CarouselModal as Component, {
                media: [{
                    attributes: {
                        alternativeText: this.$t('PP11.LOGO_ALT'),
                        url: '/images/teasers/jackbox_direct_poster.png'
                    }
                }],
                videoId: 'xV1s_4EXWG0',
                itemIndex: 0
            })
        }
    }
})
</script>

<style lang="scss" scoped>
@use "$styles/kit.scss" as *;

.pp11 {
    .hero {
        position: relative;
        margin: -90px 0 0;
    }

    .clamped {
        display: flex;
        flex-direction: row;
        gap: 30px;
        padding: 100px 20px;
    }

    .content {
        display: flex;
        flex-direction: column;
        flex: 2 0 0;

        .logo {
            width: 66%;
            height: auto;
            align-self: center;
        }

        p {
            margin-bottom: 10px;
        }
    }

    .media {
        flex: 3 0 0;
        display: flex;

        .logo {
            display: none;
        }

        button {
            cursor: pointer;
            width: 100%;
            aspect-ratio: 16/9;
            padding: 0;
            border: 2px solid transparent;
            border-radius: 10px;
            background: transparent;
            line-height: 0;
            overflow: hidden;
            transition: transform 0.1s, border 0.1s;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            &:hover {
                border: 2px solid #fff;
                transform: scale(1.02);
            }
        }
    }

    @include mq-small-and-less {
        .clamped {
            max-width: 700px;
            gap: 0px;
            flex-direction: column-reverse;
            padding-bottom: 50px;
        }

        .content {
            flex: auto;

            .logo {
                display: none;
            }

            h3, p {
                text-align: center;
            }
        }

        .media {
            flex: auto;
            text-align: center;

            .logo {
                display: inline-block;
                width: 75%;
                max-width: 300px;
                margin-bottom: 20px;
            }
        }
    }
}

.dropdown {
    color: var(--neutral-300);
    font-family: Inter;
    font-size: 14px;
    max-height: 50px;

    @include mq-medium-and-more {
        font-size: 14px;
    }

    :deep(.vs__selected) {
        // HACK: This prevents the prior selected value from jumping up
        // visually when the dropdown list is open.
        // TODO: Consider migrating to https://github.com/RemoteDevForce/tom-select
        flex-grow: 1;
        position: static;
        padding: 0;

        .selected {
            flex-grow: 1;
        }
    }

    :deep(.vs__selected-options) {
        margin-left: 16px;

        @include mq-medium-and-less {
            margin-left: 4px;
        }
    }

    :deep(.vs__open-indicator) {
        height: 16px;
        width: 16px;
        margin-right: 16px;

        @include mq-medium-and-less {
            margin-right: 4px;
        }
    }

    :deep(.vs__dropdown-toggle) {
        max-height: 50px;
    }

    .selected {
        color: var(--neutral-300);
    }
}

</style>
